import { isEmptyArray } from '@app/utils'

import type { PostExternalProductsLinkData } from '@app/api/routes/externalProductsCatalog/types'
import type { ExternalProductsCatalogDataSource } from '../types'

const getProductsMatchedWithLentaIds = (products: ExternalProductsCatalogDataSource[]): string[] => {
  return products.filter(product => product.isMatchedWithProduct).map(findedProduct => findedProduct.key)
}

const getProductsConfirmedIds = (products: ExternalProductsCatalogDataSource[]): string[] => {
  return products.filter(product => product.isConfirmed).map(findedProduct => findedProduct.key)
}

const getProductsNotConfirmedIds = (products: ExternalProductsCatalogDataSource[]): string[] => {
  return products.filter(product => !product.isConfirmed).map(findedProduct => findedProduct.key)
}

const getProductsLinkData = (
  generalProductsIds: string[],
  outerDependentProductIds?: string[]
): PostExternalProductsLinkData => {
  const oldestGeneralId = [...generalProductsIds].sort()[0]

  const dependentGeneralIds = generalProductsIds.filter(id => id !== oldestGeneralId)
  const dependentProductIds = [...dependentGeneralIds, ...(outerDependentProductIds ?? generalProductsIds)]

  return {
    generalExternalProductId: oldestGeneralId,
    dependentExternalProductIds: dependentProductIds
  }
}

export const getGeneralAndDependentProducts = (
  products: ExternalProductsCatalogDataSource[]
): PostExternalProductsLinkData => {
  const matchedWithLentaIds = getProductsMatchedWithLentaIds(products)
  const confirmedIds = getProductsConfirmedIds(products)
  const notConfirmedIds = getProductsNotConfirmedIds(products)

  if (!isEmptyArray(matchedWithLentaIds)) {
    return getProductsLinkData(matchedWithLentaIds, [...confirmedIds, ...notConfirmedIds])
  }

  if (!isEmptyArray(confirmedIds)) {
    return getProductsLinkData(confirmedIds, notConfirmedIds)
  }

  const oldestGeneralId = notConfirmedIds.sort()[0]
  const dependentNotConfirmedIds = notConfirmedIds.filter(id => id !== oldestGeneralId)

  return {
    generalExternalProductId: oldestGeneralId,
    dependentExternalProductIds: dependentNotConfirmedIds
  }
}
